module.exports = __webpack_public_path__ + "media/tulum/iguana-e1f6e4bd.jpg";